module.exports = __webpack_public_path__ + "media/limitations/vigainclinada-42b67efe.png";